import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';

import { SpanStyled, TabStyled } from './TrlTab.styles';

export const TrlTab = ({
  label,
  icon,
  value,
  index,
  disabled,
  nTabs,
  ...rest
}) => {
  const [tabWidth, setTabWidth] = useState(0);

  const tabRef = useRef(null);

  useLayoutEffect(() => {
    setTabWidth(tabRef.current.offsetWidth);
  }, []);

  return (
    <TabStyled
      ref={tabRef}
      icon={icon && <FontAwesomeIcon icon={icon} />}
      label={
        <>
          {label}
          <SpanStyled
            className="MuiTabs-indicator"
            tabWidth={tabWidth}
            {...rest}
          />
        </>
      }
      value={value ?? index}
      tabIndex={value ?? index}
      disabled={disabled}
      nTabs={nTabs}
      {...rest}
    />
  );
};

TrlTab.propTypes = {
  label: PropTypes.string,
  index: PropTypes.number,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  nTabs: PropTypes.number.isRequired,
};
